import styled from "styled-components/macro";

export const DashboardProfileLogo = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 8px;
  position: relative;
  height: 64px;

  .main-image {
    height: 24px;
  }

  .profile-logo-wrapper {
    display: flex;
    flex-direction: column;

    .profile-logo-name {
      display: flex;
      align-items: center;
      gap: 8px;

      h2 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 148px;
        color: var(--Neutral-100);
        margin: 0;
        width: 148px;
        transition: all 0.2s ease;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
      }
    }
  }
`;

export const Separator = styled.div`
  background:
    linear-gradient(
      0deg,
      rgba(31, 31, 31, 0.08) 0%,
      rgba(31, 31, 31, 0.08) 100%
    ),
    #fff;
  width: 100%;
  height: 2px;
  max-width: 240px;
  margin: 2px auto;
`;

export const IconsWrapperStyles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 140px);
  width: 100%;
  padding: 16px 12px;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  .first-set-icons-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

export const MenuListWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .sub-menu-list-wrapper {
    display: flex;
    flex-direction: column;
    padding-left: 16px;
    margin-top: 4px;
    gap: 4px;
  }
`;

export const IconTextStyled = styled.span`
  max-width: 180px;
  display: ${({ $isHovered }) => ($isHovered ? "block" : "none")};
  overflow: hidden;
  white-space: nowrap;
  font-size: 14px;
  color: var(--Neutral-100);
  display: inline-block;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IconSvgWrapper = styled.div`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px;
`;

export const IconLinkStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  padding: 10px;
  cursor: pointer;

  &:hover {
    background: var(
      --Neutral-8,
      linear-gradient(
        0deg,
        rgba(31, 31, 31, 0.08) 0%,
        rgba(31, 31, 31, 0.08) 100%
      ),
      #fff
    );
  }

  &.sub-menu-parent {
    background: transparent;
  }

  &.active {
    background: var(
      --Neutral-8,
      linear-gradient(
        0deg,
        rgba(31, 31, 31, 0.08) 0%,
        rgba(31, 31, 31, 0.08) 100%
      ),
      #fff
    );
    border-radius: 24px;

    span {
      color: var(--Brand-100);
    }
  }

  .downArrow {
    margin-left: auto;
    cursor: pointer;
  }

  .rotate {
    transform: rotate(180deg);
    transition: all 0.3s ease-in-out;
  }
`;

export const ProfileModalWrapper = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 8px;
  position: relative;
  height: 64px;

  .profile-image {
    height: 28px;
    border-radius: 50%;
    display: block;
    object-fit: cover;
  }

  .profile-details,
  .sign-out-icon {
    .user-name {
      color: var(--Neutral-100);
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: -0.028px;
      width: 128px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .user-email {
      overflow: hidden;
      color: var(--Neutral-60);
      text-overflow: ellipsis;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: -0.012px;
      width: 128px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .sign-out-icon {
    margin: 8px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;
